import { Button, NonIdealState } from '@blueprintjs/core';
import styles from './ErrorView.module.css';

interface IError {
  title: string;
  description: string;
  onReload?: () => void;
}

export function ErrorView({ title, description, onReload }: IError) {
  return (
    <NonIdealState
      className={styles.space}
      icon="heart-broken"
      title={title}
      description={description}
      action={
        onReload && (
          <Button onClick={onReload} icon="refresh" text="Reload ACE" />
        )
      }
    />
  );
}
